export default __webpack_public_path__ + "static/media/NotoSansSC-Bold.fde68b2f.ttf";